<template>
        <div class="w-full text-black">
        <div class="flex items-center justify-between pb-[18px] border-b">
            <div>
                <h2 class="text-[20px] font-light">Mot de passe</h2>
                <p class="text-[13px] font-extralight mt-2">Veuillez remplir les champs pour mettre à jour votre mot de passe</p>
            </div>
            <div class="flex items-center gap-x-[6px] font-light">
                <button class="h-[40px] border rounded-xl px-6">Annuler</button>
                <button v-on:click="updatePassword" class="h-[40px] px-6 border border-[#3c41e9] bg-[#3c41e9] text-white rounded-xl">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Sauvegarder</span>
                </button>
            </div>
        </div>
        <div class="flex items-start">
            <label for="photo" class="font-light w-[200px] pt-[18px]">Ancien mot de passe</label>
            <div class="grow py-[18px] border-b">
                <input type="text" v-model="form.old_password" placeholder="********************" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
        <div class="py-[18px] flex items-start">
            <label for="photo" class="font-light w-[200px]">Nouveau mot de passe</label>
            <div class="grow">
                <input type="text" v-model="form.new_password" placeholder="********************" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
        <div class="flex items-start">
            <label for="photo" class="font-light w-[200px] pt-[18px]">Confirmer le mot de passe</label>
            <div class="grow py-[18px] border-t">
                <input type="text" v-model="form.new_password_confirme" placeholder="********************" class="border font-extralight rounded-xl p-6 w-full h-[40px]">
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import Auth from "@/service/Auth";
import Swal from "sweetalert2";
export default {
    name: "UserBank",
    components:{
        Loader2
    },
    data(){
        return {
            form:{
                old_password: null,
                new_password: null,
                new_password_confirme: null
            },
            asSend:false
        }
    },
    methods:{
        changeStatus(){
            this.asSend = !this.asSend;
        },
        updatePassword(){
            if(this.form.new_password != this.form.new_password_confirme){
                return Swal.fire('Erreur!!!!',"Veuillez écrire deux fois le nouveau mot de passe",'error')
            }
            this.changeStatus();
            Auth.updatePassword(this.form,this.changeStatus);
        },
    }
}
</script>